export default __webpack_public_path__ + "4f7d2241a4336537496fec4b3d658fe3.jpeg";